if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.swatchesList = this.form.querySelector('.swatches-list') ?? null;
        if (this.swatchesList) {
          this.swatchesList.querySelectorAll('button.swatch').forEach((b) => {
            b.addEventListener('click', () => {
              let swatchTitle = b.dataset.variantTitle;
              let variantAvailable = b.dataset.variantAvailable;
              this.form.querySelector('.selected-shade').innerHTML = swatchTitle;
              b.closest('ul')
                .querySelectorAll('button.swatch')
                .forEach((b1) => {
                  b1.classList.remove('selected');
                });
              b.classList.add('selected');
              this.form.querySelector('input.product-variant-id').value = b.dataset.variantId;
              if (variantAvailable === 'false') {
                console.log('variant out of stock');
                b.closest('.quick-add').classList.remove('quick-add--true');
                b.closest('.quick-add').classList.add('quick-add--false');
                b.closest('.quick-add').classList.add('quick-add--variant-false');
                b.closest('.quick-add')
                  .querySelector('.manual-bis-trigger')
                  .setAttribute('data-var_id', b.dataset.variantId);
                b.closest('.quick-add')
                  .querySelector('.manual-bis-trigger')
                  .setAttribute('data-var_title', b.dataset.variantTitle);
                b.closest('.quick-add').querySelector('.manual-bis-trigger').classList.remove('hidden');
              } else {
                b.closest('.quick-add').classList.add('quick-add--true');
                b.closest('.quick-add').classList.remove('quick-add--false');
                b.closest('.quick-add').classList.remove('quick-add--variant-false');
                b.closest('.quick-add').querySelector('.manual-bis-trigger').setAttribute('data-var_title', '');
                b.closest('.quick-add').querySelector('.manual-bis-trigger').classList.add('hidden');
              }
            });
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const isBundle = formData.get('bundle') === 'true';
        formData.delete('bundle');

        config.body = formData;

        if (isBundle) {
          const bundleData = JSON.parse(
            document.querySelector(`#${evt.target.getAttribute('id')}-bundle-data`)?.textContent ?? null
          );
          if (bundleData) {
            const id = formData.get('id');
            const quantity = formData.get('quantity');
            const timestamp = Date.now();
            bundleData.items.forEach((item, index) => {
              // Set the quantity of all items to the selected quantity
              item.quantity = quantity;
              // Append a timestamp to the bundle id to make it unique
              item.properties._bundle_id = `${item.properties._bundle_id}--${timestamp}`;
              // Override the last item's id with the selected variant id
              if (index === bundleData.items.length - 1) item.id = id;
            });
            if (this.cart) {
              bundleData.sections = this.cart.getSectionsToRender().map((section) => section.id);
              bundleData.sections_url = window.location.pathname;
            }
            config.headers['Content-Type'] = 'application/json';
            config.body = JSON.stringify(bundleData);
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            const isPromo = this.dataset.formType === 'promo';
            if (isPromo) {
              const data = response;
              if (data.properties && data.properties._promotion_id) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                  event: 'pairandsave_addtocart',
                  location: Shopify.country,
                  promotion_ID: data.properties._promotion_id,
                  origin_product_name: data.product_title,
                  origin_product_cart: data.title,
                });
              }
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');

            let a = await fetch(`${window.routes.cart_url}?section_id=promotions-to-active`);
            let b = await a.text();
            let c = JSON.parse(
              new DOMParser().parseFromString(b, 'text/html').querySelector('.shopify-section').innerHTML
            );
            if (c.id) {
              const body = JSON.stringify({
                id: c.id,
                properties: c.properties,
                sections: this.cart.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname,
              });
              response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => response.text())
                .then((responseText) => JSON.parse(responseText));
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              setTimeout(() => {
                quickAddModal.hide(true);
                this.cart.open();
              }, 500);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            // this.querySelector(".loading-overlay__spinner").classList.add("hidden");
            if (!this.error) {
              this.submitButton.classList.add('added');
              this.cart.hasAttribute('data-auto-open') && this.cart.open();
              setTimeout(() => {
                this.submitButton.classList.remove('added');
                const wrapOpts = this.submitButton.closest('.product__card-options');
                if (wrapOpts) {
                  wrapOpts.classList.remove('show');
                }
                this.querySelector('.select-shade.btn') &&
                  (this.querySelector('.select-shade.btn').style.opacity = '1');
              }, 1000);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

var productCard = document.querySelectorAll('.product-card-wrapper');
if (productCard) {
  productCard.forEach((card) => {
    var selectShadeBtn = card.querySelector('.select-shade.btn');
    if (selectShadeBtn) {
      var optionsContainer = card.querySelector('.product__card-options');
      selectShadeBtn.addEventListener('click', function () {
        optionsContainer.classList.add('show');
        selectShadeBtn.style.opacity = '0';
      });
    }
  });
}
